import { useQuery } from "@apollo/client";

import { QUERY_CLIENT_PREFERENCES } from "../../../../config/graphql/query";
import { useClientId } from "../hooks/useClient";

import { DEFAULT_CHAT_LANGUAGES } from "./ChatLanguagesSetting";

/** The languages this client's chat message is written in — what the server would send. */
const useChatLanguages = (): ChatLanguage[] | undefined => {
  const clientId = useClientId();

  const { data } = useQuery<{
    client: { preferences: IClientPreferences };
  }>(QUERY_CLIENT_PREFERENCES, {
    skip: !clientId,
    variables: { id: clientId },
    context: { headers: { ClientId: clientId } },
  });

  if (!data?.client) {
    return undefined;
  }

  const languages = data.client.preferences?.chat?.languages;

  return languages?.length ? languages : DEFAULT_CHAT_LANGUAGES;
};

export default useChatLanguages;
